import React, { useState } from "react";
import "./BalanceModal.scss";

function BalanceModal({ initialData, setBalanceModal, onConfirm }) {
  const [formData, setFormData] = useState({
    login_id: initialData.login_id || "",
    email: initialData.email || "",
    balance: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    if (!formData.login_id || !formData.email || !formData.balance) {
      alert("Please fill all fields");
      return;
    }
    setIsLoading(true);
    try {
      await onConfirm(formData);
      setBalanceModal(false);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="balanceModal_wrapper">
      <div className="modal_content">
        <h2>Update Balance</h2>
        <div className="input_group">
          <label>Login ID</label>
          <input
            type="text"
            name="login_id"
            value={formData.login_id}
            onChange={handleChange}
            placeholder="Enter Login ID"
            readOnly
          />
        </div>
        <div className="input_group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter Email"
            readOnly
          />
        </div>
        <div className="input_group">
          <label>Balance</label>
          <input
            type="number"
            name="balance"
            value={formData.balance}
            onChange={handleChange}
            placeholder="Enter Amount"
          />
        </div>
        <div className="buttons_wrapper">
          <button
            className="confirm"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Confirm"}
          </button>
          <button className="cancel" onClick={() => setBalanceModal(false)}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

export default BalanceModal;
